import { Text, useMantineColorScheme } from "@mantine/core";
import { getBaseGlassStyles } from "../common/BaseContainer";
import { ItemActionsMenu } from "./ItemActionsMenu";

interface FolderGridItemProps {
    id: string;
    name: string;
    description?: string | null;
    type: "report" | "dashboard" | "chart" | "form" | "tab_group" | "folder";
    icon: React.ReactNode;
    onClick: () => void;
    onMove: (type: any, id: string) => void;
    onDelete: (type: any, id: string) => void;
    onViewDetails?: (type: any, id: string) => void;
    onEdit?: (type: any, id: string) => void;
    deleteLabel?: string;
}

export const FolderGridItem = ({
    id,
    name,
    description,
    type,
    icon,
    onClick,
    onMove,
    onDelete,
    onViewDetails,
    onEdit,
    deleteLabel
}: FolderGridItemProps) => {
    const { colorScheme } = useMantineColorScheme();

    return (
        <div
            className="group flex items-center gap-3 rounded-md border p-3 transition relative hover:bg-gray-100/50 dark:hover:bg-white/5 w-full min-w-0"
            style={getBaseGlassStyles(colorScheme)}
        >
            <button
                className="flex-1 flex items-center gap-3 text-left min-w-0 overflow-hidden"
                onClick={onClick}
            >
                <div className="flex h-8 w-8 items-center justify-center flex-shrink-0">
                    {icon}
                </div>
                <div className="flex-1 min-w-0 overflow-hidden">
                    <Text fw={500} className="truncate block">
                        {name}
                    </Text>
                    {description && (
                        <Text size="xs" c="dimmed" className="truncate block">
                            {description}
                        </Text>
                    )}
                </div>
            </button>

            <div className="flex-shrink-0">
                <ItemActionsMenu
                    type={type}
                    id={id}
                    onMove={onMove}
                    onDelete={onDelete}
                    onViewDetails={onViewDetails}
                    onEdit={onEdit}
                    deleteLabel={deleteLabel}
                />
            </div>
        </div>
    );
};
